var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_user-agent.js
// module id = 133
// module chunks = 48 49 50 51